export const qaLabelReports = {
    jobNameInput: 'reports-filter--job-name-input',
    jobStatusInput: 'reports-filter--job-status-input',
    teamsInput: 'reports-filter--teams-input',
    driversInput: 'reports-filter--drivers-input',
    filterButton: 'reports-filter-btn',

    applyFiltersButton:'reports-filter-apply-btn',
    addCampaignButton: 'campaign--add-campaign',
};
